import { Selector, createSelector } from 'reselect'
import { networkGroup } from './utils'

import {
  IRecord_User,
} from '@kaidam/fc-shared/src/types/schema/user'

import {
  ADMIN_USERS,
} from '@kaidam/fc-shared/src/constants'

import {
  RootState,
} from '../../types/store'

export const loaded: Selector<RootState, boolean> = state => state.auth.loaded
export const data: Selector<RootState, IRecord_User | null> = state => state.auth.data
export const token: Selector<RootState, string> = state => state.auth.token
export const loggingOut: Selector<RootState, boolean> = state => state.auth.loggingOut

export const isAdminUser = createSelector(
  data,
  (user) => {
    if(!user) return false
    return ADMIN_USERS.indexOf(user.email) >= 0
  }
)

// Mirrors isAdminOrStaff in packages/api/src/controllers/rbac.ts: only these
// may change another person's password or email. /auth/status sets user.admin
// from the server's ADMIN_USERS env.
export const isAdminOrStaff = createSelector(
  data,
  (user) => {
    if(!user) return false
    if(user.admin || user.system?.admin || user.system?.impersonate || user.meta?.admin) return true
    const email = (user.email || '').toLowerCase()
    return ADMIN_USERS.some(e => (e || '').trim().toLowerCase() == email)
  }
)

export const network = networkGroup('auth', [
  'login',
  'register',
  'resetPassword',
])

export default {
  loaded,
  data,
  token,
  loggingOut,
  isAdminUser,
  isAdminOrStaff,
  network,
}